// extracted by mini-css-extract-plugin
module.exports = {"C285_DonationTool_GivingTech":"C285_DonationTool_GivingTech_C285_DonationTool_GivingTech__TcJdv"};